import { duplicateGoal as _duplicateGoal } from '@griply/services';
import { buildEntityLinks, getSubGoals } from '@griply/utils';
import {
  collection,
  doc,
  Firestore,
  serverTimestamp,
  Timestamp,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { Goal } from 'shared/types/goal';

import { getGoals } from './get-goals';
import { getRelationshipDocs } from './get-relationships';
import { getTasksWithSubTasks } from './get-tasks-with-sub-tasks';
import { getDatabase } from './helpers';

export const duplicateGoal = async (goal: Goal) => {
  const [goals, relationships] = await Promise.all([
    getGoals(),
    getRelationshipDocs(),
  ]);
  const links = buildEntityLinks(relationships);
  const subGoals = getSubGoals(goal.id, { goals, recursive: true, links });
  const tasks = await getTasksWithSubTasks({
    goals: [goal.id, ...subGoals.map(({ id }) => id)],
  });

  return _duplicateGoal({
    goal,
    subGoals,
    tasks,
    links,
    collection,
    doc,
    db: getDatabase(),
    serverTimestamp,
    timestampFromDate: Timestamp.fromDate,
    writeBatch: (db) => writeBatch(db as Firestore),
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.DuplicateGoal,
        error,
      }),
  });
};
